import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import "./Donatorji.css";
import { useTranslation } from "react-i18next";

const events = [
  { image: "/Slike/Donatorji/eles.webp", alt: "ELES" },
  { image: "/Slike/Donatorji/kea.webp", alt: "Trgovina KEA" },
  { image: "/Slike/Donatorji/kocevar.webp", alt: "Ograje Kočevar" },
  { image: "/Slike/Donatorji/ledx.webp", alt: "LedX" },
  { image: "/Slike/Donatorji/Mana.webp", alt: "Mana" },
  { image: "/Slike/Donatorji/minitec.webp", alt: "Minitec" },
  { image: "/Slike/Donatorji/petre.webp", alt: "Petre šotori" },
  { image: "/Slike/Donatorji/remontng.webp", alt: "Remont NG" },
  { image: "/Slike/Donatorji/zavarovalnicatriglav.webp", alt: "Zavarovalnica Triglav" },
  { image: "/Slike/Donatorji/celjskisejem.webp", alt: "Celjski sejem" },
  { image: "/Slike/Donatorji/bionic.webp", alt: "bionic medical" },
  { image: "/Slike/Donatorji/kminstalacije.webp", alt: "KM Inštalacije" },
  { image: "/Slike/Donatorji/vidim.webp", alt: "Vidim očesni center" },
  { image: "/Slike/Donatorji/Faraon.webp", alt: "Hotel in Casino Faraon Celje" },
  { image: "/Slike/Donatorji/123invest.webp", alt: "123 Invest" },
  { image: "/Slike/Donatorji/nepo.webp", alt: "Nepo inženiring" },
  { image: "/Slike/Donatorji/agentinepremicnine.webp", alt: "Agenti Nepremičnine" },
  { image: "/Slike/Donatorji/fmprojekti.webp", alt: "FM Projekti" },
  { image: "/Slike/Donatorji/iskra.webp", alt: "Iskra esv d.d" },
  { image: "/Slike/Donatorji/lekarnavransko.webp", alt: "Lekarna Vransko" },
  { image: "/Slike/Donatorji/qalita.webp", alt: "Qualita trgovina in storitve" },
  { image: "/Slike/Donatorji/rcom.webp", alt: "Rcom mednarodna skupina" },
  { image: "/Slike/Donatorji/rein.webp", alt: "Rein skupina d.o.o." },
  { image: "/Slike/Donatorji/sanles.webp", alt: "Sanles d.o.o." },
  { image: "/Slike/Donatorji/seba.webp", alt: "Seba trgovina, proizvodnja in zaključna dela v gradbeništvu d.o.o." },
  { image: "/Slike/Donatorji/speh.webp", alt: "Slikopleskrstvo in fasaderstvo Špeh" },
  { image: "/Slike/Donatorji/termosolar.webp", alt: "Termosolar strojne inštalacije" },
  { image: "/Slike/Donatorji/viba.webp", alt: "Viba gradbena oprema in stroji" },
];

const Donatorji = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        const rect = ref.current.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.75) setVisible(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="donatorjikontejnert">
      <div className="donatorjiheading">
    
          <h2 style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            {t("donors_supporters_title")}
          </h2>
       
        <p  className="donatorjipodnaslov">{t("donors_supporters_subtitle")}</p>
      </div>

      <div ref={ref} className={`donatorjieventgallery ${visible ? "visible" : "hidden"}`}>
        <div className="donatorjigallerygrid">
          {events.map((event, index) => (
            <div className="donatorjigalleryitem" key={index}>
              {event.link ? (
                <Link to={event.link} className="donatorjiimagecontainer" aria-label={event.alt}>
                  <img
                    src={process.env.PUBLIC_URL + event.image}
                    alt={event.alt}
                    className="donatorjigalleryimage"
                    loading="lazy"
                  />
                  <div className="donatorjioverlay">
                    <p className="donatorjieventtitle">{event.alt}</p>
                  </div>
                </Link>
              ) : (
                <div className="donatorjiimagecontainer" role="img" aria-label={event.alt} tabIndex={0}>
                  <img
                    src={process.env.PUBLIC_URL + event.image}
                    alt={event.alt}
                    className="donatorjigalleryimage"
                    loading="lazy"
                  />
                  <div className="donatorjioverlay">
                    <p className="donatorjieventtitle">{event.alt}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="donatorjisp1">
          <p>
            SPONZORJI V STORITVAH
            <br />
            <br />
            MVM D. O .O / SAZAS / Radio Fantasy / Foto Rojnik / D. Pražnikar / VTV / TV Celje / Petre d.o.o /
            (Oglaševanje v dvorani - Katja in Andrej) / OŠ Vransko Tabor / Ozvočenje Rak / Občina Tabor / Savinjske
            novice /
          </p>
        </div>
      </div>
    </div>
  );
};

export default Donatorji;
